import { useEffect, useState } from 'react';
import BackButton from './BackButton';

interface FullHeightContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  showBackButton?: boolean;
}

export default function FullHeightContainer({ 
  children, 
  style = {}, 
  showBackButton = false 
}: FullHeightContainerProps) {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      style={{
        height: `${height}px`,
        overflowY: 'hidden',
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        background: 'transparent',
        ...style,
      }}
    >
      {showBackButton && <BackButton />}
      {children}
    </div>
  );
}

